import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login/login.service';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-star-resources',
  templateUrl: './star-resources.component.html',
  styleUrls: ['./star-resources.component.css']
})
export class StarResourcesComponent implements OnInit {

  leftMenu1 = true;
  leftMenu2 = false;
  leftMenu3 = false;

  constructor(private service: LoginService, private router: Router) { }

  ngOnInit() {

  }

  // 星群资源
  product(num: number) {
    switch (num) {
      case 1:
        localStorage.setItem('type', "高分卫星数据")
        this.router.navigate(["/starResources/productDisplay"])
        this.leftMenu1 = true
        this.leftMenu2 = false
        this.leftMenu3 = false
        break
      case 2:
        localStorage.setItem('type', "其他国产卫星数据")
        this.router.navigate(["/starResources/otherSat"])
        this.leftMenu1 = false
        this.leftMenu2 = true
        this.leftMenu3 = false
        break
      case 3:
        localStorage.setItem('type', "国外卫星数据")
        this.router.navigate(["/starResources/outsideSat"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = true
        break
    }

  }

}
